export default "__VITE_ASSET__CPy9ep____"